
import BaseView from "@core/View.js";
import { $util } from "@util/util.js";
import { toast } from '@shared/utils/biz_utils';
export default class CTOWapView extends BaseView {
  constructor(model) {
    super(model);
    this._model._view = this;
    this._parentEl = this._model._parent._view._extraBoxEl;
  }
  _priceShow(item) {
    if (item._price) {
      return '¥'
    } else {
      return ''
    }
  }
  getImages(item) {
    if (!!item?._pturl) {
      return `<img src="${item._pturl}"> <div class="disable_img"></div>`
    } else {
      return ''
    }
  }
  getItems() {
    let html = "";
    this._model._items.forEach((item, idx) => {
      const isA = item._ptside.toUpperCase() == 'A';
      html += `<div class="item_content ${this.getInvalidInfo(item).cls}">
            <div class="e_goods_img">
              ${this.getImages(item)}
             
            </div>
            <div class="e_goods_desc" style="position:relative;">
              <span class="le_tip_btn_solid" style="display:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0) ? 'inline-block' : 'none'}">${this.getInvalidInfo(item).msg}</span>
              <h6 class='lenovo-emoji' style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0) ? '0.5' : '1'}">
              ${this.getPtsideMsgAndPtWord(item)}
              </h6>
              <span style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0) ? '0.5' : '1'}" class="e_price"> ${this._priceShow(item)}${item._price}</span>
              <span style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0) ? '0.5' : '1'}" class="e_num">x${this._model._parent._count}</span>
             
              <span class="fr e_action" tag='e_actions' latag="latag_wap_购物车_私人定制${isA ? 'A面' : 'C面'}_0_null_重选" style="position:absolute;right:0rem;display:${!this._model._parent._invalid ? "block" : "none"};" code="${item._parent._parent._id}" _ptside="${item._ptside}">重选<i class="iconfont icon-arrow-right  le_vertical_align_m"></i></span>
            </div>
        </div>`;
    });
    return html;
  }
  
  getPtsideMsgAndPtWord(item) {
    let htmlStr = '';
    if(item?._picName){
      htmlStr += item._ptsideMsg + ' ';
      htmlStr += item._picName;
    }else{
      if(item?._ttfUrl && item?._fontName){
        let fontFamily = `personal-font-${item._fontId}`;
        const style = document.createElement('style');
        style.textContent = `
            @font-face {
                font-family: '${fontFamily}';
                src: url('${item._ttfUrl}') format('truetype');
            }
        `;
        document.head.appendChild(style);
        htmlStr += `<span style="font-family: '${fontFamily}', 'lenovo-emoji'">${item._fontName}</span>`+ ' ';
        htmlStr += `<span class="carveContent" style="font-family: '${fontFamily}', 'lenovo-emoji'">${item._ptword}</span>`;
      }else{
        htmlStr += item._ptsideMsg + ' ';
        htmlStr += `<span class="carveContent" style="font-family: 'lenovo-emoji'">${item._ptword}</span>`;
      }
    }
    return htmlStr;
  }


  render() {
    let html = "";
    html += `<div class="extra_item custom ${this.getInvalidInfo().cls}"> 
                  <h3 class="e_name">
                    私人定制
                  </h3>
                  <div class="extra_item_content">
                    ${this.getItems()}
                </div>
            </div>`;
    $(this._parentEl).append($(html));
    this.regEvent();
  }

  regEvent() {
    let that = this;
    // 点击重新按钮，弹出私人定制页面
    this._parentEl.off("click", "[tag='e_actions']").on("click", "[tag='e_actions']", function () {
      let _ptside = $(this).attr('_ptside')
      let code = $(this).attr('code')
      let params = {
        code: code
      }
      that._model._parent.getPersonalGoods(params).then(
        x => {

          if (_ptside == "A" || _ptside == "L") {
            const materialCode = that._model._parent._data && that._model._parent._data.materialCode;
            let personalizations = that._model._parent._data.personalizations
            let indexs = 0

            if (personalizations && personalizations.length > 0) {
              let data = that._model._parent._personalGoods
              let datas = ''
              personalizations.map((item, index) => {
                if (item.ptside == 'A' || item.ptside == 'L') {
                  datas = item
                }
              })
              data._aSideData.map((item, index) => {
                if (item.code == datas.ptcode) {
                  indexs = index
                }
              })
              that._model._parent.getPersonalPicturess({ code: datas.ptcode }).then(x => {
                that._model._parent._personalGoods.aPriceCode = datas.ptcode
                if(datas.ptside == 'A'){
                  that._model._parent._personalGoods._view.render('A', indexs, '', materialCode)
                }
                if(datas.ptside == 'L'){
                  that._model._parent._personalGoods._view.render('L', indexs, '', materialCode)
                }
              })
                .catch(err => {
                  if(datas.ptside == 'A'){
                    that._model._parent._personalGoods._view.render('A', indexs, '', materialCode)
                  }
                  if(datas.ptside == 'L'){
                    that._model._parent._personalGoods._view.render('L', indexs, '', materialCode)
                  }
                })
            } else {
              if(datas.ptside == 'A'){
                that._model._parent._personalGoods._view.render('A', indexs, '', materialCode)
              }
              if(datas.ptside == 'L'){
                that._model._parent._personalGoods._view.render('L', indexs, '', materialCode)
              }
            }

            $("#customized_pop").addClass("in");
            $util.toggleBodyScroller(true);
          } else {
            // 校验：position 接口 machineInfo.mobileList 中若每个对象的 tabTitle 都为空，则该商品不支持私定刻字
            const mobileList = that._model._parent._personalGoods?.machineInfo?.mobileList || [];
            const hasTab = mobileList.some(item => item?.tabTitle);
            if (!hasTab) {
              toast('该商品暂不支持私定刻字，请重新下单');
              return;
            }
            const carveContentDom = $(this.parentElement).find('.carveContent')
            that._model._parent._personalGoods.cPTword = carveContentDom.text()
            if (that._model._parent._personalGoods._cSideData.length > 0) {
              that._model._parent._personalGoods._view.render('C', 0)
              $("#customized_pop_c").addClass("in");
              $util.toggleBodyScroller(true);
            } else {
              throw ("没有C面定制信息")
            }

          }
        }
      ).catch(err => {
        // position 接口返回 404（未配置有效私定数据）：toast 接口文案
        if (err?.code == 404) {
          toast(err?.msg || '未配置有效私定数据');
          return;
        }
        // $(".pop_cto").show();
        // let html = `  <div class="service_pro">
        //     <div class="img_box">
        //       <div class="srdz_img_con">
        //         <img id="srdz_spimage" src=${that._model._parent._data.imgUrl}></div>
        //     </div>
        //     <div class="srdz_price_wrap">
        //       <div>
        //         <p class="srdz_pop_mall">
        //           <i>¥</i>
        //              <span id="srdz_spprice">${that._model._parent._data.price.showAmount}</span>
        //         </p>
        //         <p class="srdz_pop_code">商品编号:
        //           <span id="srdz_spbh">${that._model._parent._data.id}</span>
        //         </p>
        //       </div>
        //     </div>
        //     <i class="fr iconfont icon-close srdz_pop_close" tag="onClickNoneC"></i>
        //   </div>
        //   <div class='topcenter'>
        //   <img src="//p3.lefile.cn/product/adminweb/2021/01/20/305BcNiY3N9cRgxZcvCcIlhFc-9737.png" alt="">
        //   <div>暂无私人定制</div>
        //   </div>`
        // $(".pop_cto").html(html);
        // $util.toggleBodyScroller(true);
      });
    })

    $(".pop_cto").off("click", "[tag='onClickNoneC']").on("click", "[tag='onClickNoneC']", function (e) {
      $(".pop_cto").hide()
      $util.toggleBodyScroller(false);
    })
  }
}